import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { provideLeerplus } from '@gametailors/leerplus';
import { InstanceDeserializer } from '@gametailors/lp-studio-connector';
import { LpSchema } from '../../typings/schema';
import { PronunciationService } from '../services/pronunciation.service';
import { TextsService } from '../services/texts.service';
import { STUDIO_API_DATA_PACKAGE_PROVIDER } from './rid-game.provider';

export function provideLeerplusRidGame(): (Provider | EnvironmentProviders)[] {
  return [
    PronunciationService,
    TextsService,
    provideLeerplus(),
    provideAppInitializer(async () => {
      const $pronunciationService = inject(PronunciationService);
      const $textsService = inject(TextsService);

      const datapackageProvider = STUDIO_API_DATA_PACKAGE_PROVIDER;
      const [schema, files, dataPackage] = await Promise.all([
        datapackageProvider.getSchema(),
        datapackageProvider.getFileMetas(),
        datapackageProvider.getDataPackage(),
      ]);
      const instances = new InstanceDeserializer<LpSchema['all']>(schema, files, dataPackage.variables).deserializeMany(
        dataPackage.instances,
      );
      await Promise.all([
        $pronunciationService.initialize(instances),
        $textsService.initialize(instances.filter((i) => i.dataType === 'RIDTexts')),
      ]);
    }),
  ];
}
